module.exports = __webpack_public_path__ + "img/big_1_58.8710abe9.png";